import { connect } from 'react-redux';

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";



const Contact = ({auth}) => {          

        return (

        <>
            <div className="pt-5">    
                <Row className="primary-font-color" style={{ paddingTop:"50px", paddingBottom: "20px", overflow:"hidden" }}>
                    <Col xs={1}></Col>
                    <Col xs={10}>       
                            
                        <Row style={{ paddingTop: "20px", color:"#000000" }}>
                            <Col xs={12}>WAITLIST</Col>
                        </Row>                        
                        <Row className="mt-4" style={{fontSize:"0.9rem"}}>
                            <Col xs={12}>                                
                                Thanks for signing up for our waitlist! You should have received an email with more information including how to get access to the product.
                                <br /><br />
                                If you have any questions, just reply to the Waitlist email and it'll go directly to our founder.
                            </Col>
                        </Row>
                        
                    </Col>                            
                </Row>
            </div>
        </>
        );    
};

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(Contact);
